export const CHANGE_STATUS_MODE = "CHANGE_STATUS_MODE";
export const CHANGE_SATUTS_REVIEW = "CHANGE_SATUTS_REVIEW";